import { cn } from "@/lib/utils";

export const PageHeader = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <header className={cn("flex shrink-0 flex-col gap-1 pl-16 pt-4 md:p-8 md:pb-4", className)}>{children}</header>
  );
};
